import React, { useEffect, useLayoutEffect, useRef } from "react";
import "./Popup.scoped.scss";
import { setPopup } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";

const Popup = () => {
  const { state, dispatch } = useStore();
  const { popup } = state;
  const { mainTitle, subTitle, mainButtonText, mainButtonAction, secondaryButtonText, closingAction, isOpen, scrollTop, tagManagerPush, secondaryButtonAction } = popup;
  const popupRef = useRef();

  const resetScrollPosition = () => {
    document.body.style.overflow = "auto";
    // window.scrollTo({ top: (scrollTop || 0) + (document.querySelector(".popup_area")?.offsetHeight || 0) });
  }

  useLayoutEffect(() => {
    if (isOpen) {
      dispatch(setPopup({ ...popup, popupRef }));
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen === false) {
      resetScrollPosition();
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const close = (e, shouldCallClosingAction) => {

    e.preventDefault();
    shouldCallClosingAction && typeof (closingAction) === "function" && closingAction();
    resetScrollPosition();
    dispatch(setPopup({ isOpen: false, popupRef: null }));
  };

  return (
    <div className="popup_area">
      <div className="popup_wrap">
        <div className="popup_box" ref={popupRef}>
          {mainTitle || subTitle ?
            <>
              <h2>{mainTitle}</h2>
              <div className={subTitle? "": "subTitle"}>{subTitle}</div>
              {
                mainButtonAction && mainButtonText &&
                <div className="popup_btn_wrap update_btn_wrap">
                  <a href="javascript:void(0)" className="popup_btn update_btn" onClick={(e) => { e.preventDefault(); mainButtonAction(); }}>{mainButtonText}</a>
                </div>
              }
              {
                secondaryButtonText &&
                <span className="popup_btn_link_wrap">
                  <a href="javascript:void(0)" className="popup_btn_link" onClick={(e) => {
                    e.preventDefault();
                    if (typeof (secondaryButtonAction) === "function") {
                      secondaryButtonAction();
                    }

                    close(e, true);

                  }}>
                    {secondaryButtonText}</a>
                </span>
              }
            </> :
            <></>
          }
        </div>
        <div className="popup_close_icon" onClick={(e) => { close(e, false); tagManagerPush?.(); }}>
          <a href="javascript:void(0)" onClick={e => { e.preventDefault(); }}>
            <i className="fa ion-android-close"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Popup;

export const openPopup = (dispatch, mainTitle, subTitle, mainButtonText, mainButtonAction, closingAction, secondaryButtonText, tagManagerPush, secondaryButtonAction, mobileCenter) => {
  const scrollTop = document.documentElement.scrollTop;
  // document.body.style.overflow = "hidden";
  //window.scrollTo({ top: 0 });
  dispatch(setPopup({
    isOpen: true,
    mainTitle,
    subTitle,
    mainButtonText,
    mainButtonAction,
    closingAction,
    secondaryButtonText,
    scrollTop,
    tagManagerPush,
    secondaryButtonAction,
    mobileCenter
  }));
};

